import { render, staticRenderFns } from "./DetailHandleList.vue?vue&type=template&id=44e83852&scoped=true&"
import script from "./DetailHandleList.vue?vue&type=script&lang=js&"
export * from "./DetailHandleList.vue?vue&type=script&lang=js&"
import style0 from "./DetailHandleList.vue?vue&type=style&index=0&id=44e83852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e83852",
  null
  
)

export default component.exports